import React from 'react';
import TelehealthImage from '../../../assets/images/home_screen/telehealth.webp';
import { motion } from 'framer-motion';
import GradientButton from '../../../components/atoms/GradientButton';

const Telehealth = () => {
  const Content = () => {
    return (
      <main className="relative w-full flex items-center justify-center lg:px-4 py-10 md:py-20">
        <div className="relative w-full max-w-[1120px] px-4 md:px-10 py-8 md:py-10 flex flex-col md:flex-row items-center md:items-start md:text-left gap-10 bg-[#EBF2FA]">
          <div className="absolute hidden md:block -right-[1000px] w-[1500px] bg-[#EBF2FA] h-full top-0 z-0"></div>
          <img
            src={TelehealthImage}
            alt="Telehealth video call with pediatric therapists conducting virtual therapy session"
            className="md:w-auto md:h-[290px] my-auto object-contain z-10"
          />
          <div className="flex flex-col gap-2 flex-1 z-10">
            <h2 className="text-4xl md:text-5xl text-primary font-bold">
              Telehealth
            </h2>
            <p className="text-secondary text-lg xl:max-w-[460px] my-3">
              In recent years, telehealth has revolutionized the way we access
              healthcare services, and pediatric therapy is no exception.
              Through the power of technology, our telehealth offering brings
              therapy sessions right into the homes of children and their
              families, offering convenience, accessibility, and meaningful
              support. We can help you explore the many benefits of telehealth
              for pediatric therapy and how it is transforming the landscape of
              child development services.
            </p>
            <GradientButton
              text={'Schedule Now'}
              navigateTo={'/contact'}
              width={'w-full sm:w-[200px]'}
            />
          </div>
        </div>
      </main>
    );
  };

  return (
    <>
      <motion.h1
        initial={{ opacity: 0, x: 500 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        viewport={{ once: true, amount: 0.5 }}
        className="hidden md:block"
      >
        <Content />
      </motion.h1>
      <div className="block md:hidden">
        <Content />
      </div>
    </>
  );
};
export default Telehealth;
